import {
  Box,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { useHistory } from "react-router";
import InfoIcon from "src/components/Icon/InfoIcon";
import Empty from "src/components/utils/Empty";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { TOP_COLOR_LIST } from "src/config/styleConfig";
import { numberWithCommas, toFixed } from "src/services/utils";

const useStyle = makeStyles((theme) => ({
  icon: {
    color: theme.palette.text.secondary,
    fontSize: "14px",
  },
}));

export default function BaseTable({ tableId, title, tableHeaderConfig, data }) {
  const cls = useStyle();
  const history = useHistory();

  const onRowClick = (tokenId) => {
    history.push(`/tokens-health/${tokenId}`);
  };

  return (
    <PaperWrapper title={title} paperProps={{ style: { padding: 0 } }}>
      <TableContainer style={{ borderRadius: "10px" }}>
        <Table style={{ tableLayout: "fixed" }}>
          <TableHead>
            <TableRow>
              {tableHeaderConfig.map((element, index) => {
                return (
                  <TableCell key={index} colSpan={4}>
                    <Box display="flex">
                      <Typography>{element["title"]}</Typography>
                      {element?.tooltip && <InfoIcon title={element.tooltip} className={cls.icon} />}
                    </Box>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((element, index) => {
              return (
                <TableRow key={index} onClick={() => onRowClick(element.token_id)}>
                  <TableCell colSpan={4}>
                    <Box display="flex" justifyContent="flex-start" alignItems="center">
                      <div
                        style={{
                          width: "12px",
                          height: "12px",
                          marginRight: "0.25rem",
                          borderRadius: "2px",
                          background: TOP_COLOR_LIST[index],
                        }}
                      ></div>
                      <Typography>Top {index + 1}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell colSpan={4}>
                    <Typography>{element.symbol}</Typography>
                  </TableCell>
                  <TableCell colSpan={4}>
                    {tableId === "top5PriceIncrease" && (
                      <Typography style={{ color: "#4eaf0a" }}>
                        {numberWithCommas(toFixed(element.figure, 2))} %
                      </Typography>
                    )}
                    {tableId === "top5PriceDecrease" && (
                      <Typography style={{ color: "#e15241" }}>
                        - {numberWithCommas(toFixed(element.figure, 2))} %
                      </Typography>
                    )}
                    {tableId !== "top5PriceIncrease" && tableId !== "top5PriceDecrease" && (
                      <Typography>{numberWithCommas(toFixed(element.figure, 2))}</Typography>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {data?.length == 0 && (
        <Box textAlign="center">
          <Empty title="No Data" iconProps={{ style: { fontSize: "60px" } }} />
        </Box>
      )}
    </PaperWrapper>
  );
}
